import React from 'react';
import { FaCheck } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const TradingPlans = () => {
  const plans = [
    {
      title: `Student Plan`,
      subtitle: `Essential Trading`,
      amount: `£100 - £1,999.99`,
      features: [
        `Entry-level automated trading algorithms.`,
        `Trade execution on select cryptocurrency exchanges.`,
        `Basic portfolio tracking.`,
        `Email support with 48-hour response time..`,
        `Access to beginner-level educational resources.`,
      ],
    },
    {
      title: `Basic Plan`,
      subtitle: `Essential Trading`,
      amount: `£2000.00 - £19,999.99`,
      features: [
        `All features of the Basic Plan.`,
        `Limited access to automated trading algorithms.`,
        `Trade execution on select cryptocurrency exchanges.`,
        `Basic portfolio tracking.`,
        `Email support with 48-hour response time.`,
        `Access to beginner-level educational resources.`,
      ],
    },
    {
      title: `Standard Plan`,
      subtitle: `Essential Trading`,
      amount: `£20,000.00 - £49,999.99`,
      features: [
        `All features of the Basic Plan.`,
        `Access to introductory automated trading algorithms.`,
        `Trade execution on popular cryptocurrency exchanges.`,
        `Basic portfolio tracking and performance overview.`,
        `Email support with 24-hour response time.`,
        `Access to beginner to intermediate educational resources.`,
      ],
    },
    {
      title: `Bronze Plan`,
      subtitle: `Essential Trading`,
      amount: `£50,000 - £99,999.99`,
      features: [
        `All features of the Starter Plan.`,
        `Access to advanced automated trading algorithms.`,
        `Trade execution on major cryptocurrency exchanges.`,
        `Portfolio tracking and performance analytics.`,
        `Email support with 24-hour response time.`,
        `Limited access to educational resources.`,
      ],
    },
    {
      title: `Silver Plan`,
      subtitle: `Advanced Trading`,
      amount: `£100,000.00 - £500,000.00`,
      features: [
        `All features of the Silver Plan.`,
        `Advanced trading algorithms with customizable parameters.`,
        `Priority trade execution for faster transactions.`,
        `Dedicated customer support with live chat.`,
        `Access to premium educational materials and webinars.`,
      ],
    },
    {
      title: `Gold Plan`,
      subtitle: `Professional Trading`,
      amount: `£500,000.00 - £999,999.99`,
      features: [
        `All features of the Gold Plan.`,
        `Exclusive access to proprietary trading strategies.`,
        `Personalized portfolio management assistance.`,
        `Priority customer support with phone assistance.`,
        `Invitation to VIP events and workshops.`,
      ],
    },
    {
      title: `Platinum Plan`,
      subtitle: `Elite Trading`,
      amount: `£1,000,000.00 - £5,000,000.00`,
      features: [
        `All features of the Platinum Plan.`,
        `Unlimited access to all trading algorithms and strategies.`,
        `1-on-1 consultations with experienced traders.`,
        `Custom development of trading bots tailored to your needs.`,
        `Access to exclusive market insights and analysis reports.`,
      ],
    },
    {
      title: `Diamond Plan`,
      subtitle: `Elite Trading`,
      amount: `£5,000,000.00 above`,
      features: [
        `All features of the Platinum Plan.`,
        `Unlimited access to all trading algorithms and strategies.`,
        `1-on-1 consultations with experienced traders.`,
        `Custom development of trading bots tailored to your needs.`,
        `Access to exclusive market insights and analysis reports.`,
      ],
    },
  ];

  return (
    <main className='content trading-plans-page'>
      <div className='title'>
        <h2>Trading Plans</h2>
      </div>
      <div className='grid'>
        {plans.map((plan, planIndex) => {
          const { amount, features, subtitle, title } = plan;
          return (
            <div className='card' key={planIndex}>
              <div className='title'>
                <h3>{title}</h3>
                <h4>{subtitle}</h4>
              </div>

              <div className='amount'>
                <h3>{amount}</h3>
              </div>

              <div className='list'>
                <h3>Features</h3>
                <ul>
                  {features.map((feature, featureIndex) => {
                    return (
                      <li key={featureIndex}>
                        <FaCheck /> {feature}
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className='btn'>
                <Link to='/dashboard/deposit'>
                  <button className='linear'>Invest Now</button>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </main>
  );
};

export default TradingPlans;
